import { ACTION } from "../transactions/types";
import { APP_CONFIG, defaultHeaders } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { ROUTE } from "../../../routes";
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const getEmailStatement = async (action, _datastore, { navigate, setDatastore, asyncStorage, showPopup, instrumentTrack }) => {
    console.warn("**** getEmailStatement action triggered ****", action);
    await setDatastore(action.routeId, "EmailStatementPage", {
        emailStatementButtonLoading: true,
    });
    const requestOptions = {
        method: "GET",
        headers: await defaultHeaders(),
    };
    const accountId = (await SharedPropsService.getUser())
        .linkedBorrowerAccounts[0].accountId;
    await fetch(`${api.pdfEmail}${accountId}`, requestOptions)
        .then((response) => {
        response.json();
        if (response.status === 200) {
            setDatastore(action.routeId, "EmailStatementPage", {
                emailStatementButtonLoading: false,
            });
            showPopup({
                id: 'bt_mfPledge_continue',
                autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
                type: "SUCCESS",
                title: "Email sent successfully",
                subTitle: "Transaction details have been sent to your email address.",
                ctaLabel: "Continue",
                ctaAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.EMAIL_STATEMENT,
                    payload: {},
                },
                primary: false,
            });
        }
        else {
            setDatastore(action.routeId, "EmailStatementPage", {
                emailStatementButtonLoading: false,
            });
            showPopup({
                autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
                type: "FAILED",
                title: "Email sent unsuccessfully",
                subTitle: "Transaction details were not sent to your email address.",
                ctaLabel: "Try again later",
                ctaAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.TRANSACTIONS,
                    payload: {},
                },
                primary: false,
            });
        }
    })
        .catch((error) => async () => {
        console.log("error", error);
        await setDatastore(action.routeId, "EmailStatementPage", {
            emailStatementButtonLoading: false,
        });
        showPopup({
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: "FAILED",
            title: "Email sent unsuccessfully",
            subTitle: "Transaction details were not sent to your email address.",
            ctaLabel: "Try again later",
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.TRANSACTIONS,
                payload: {},
            },
            primary: false,
        });
    });
};
